
import { useNavigate } from 'react-router';
import { useEffect } from 'react';

import { useGetAppContext } from '@/services/context/queries';

import { LogoutSection } from './logout-section';

export function Logout() {
  const navigate = useNavigate();
  const { isError, isLoading } = useGetAppContext();

  useEffect(() => {
    if (!isLoading && isError) {
      navigate('/', { replace: true });
    }
  }, [isError, isLoading, navigate]);

  return <LogoutSection />;
}
